import axios from "axios";

import {
  FETCH_QUIZRESULTS,
  FETCH_QUIZRESULT,
  FETCH_QUIZRESULT_SUMMARY,
  LOADING_QUIZRESULTS,
  DELETE_QUIZRESULT
} from "./type";

// Fetch all quiz results with filtering and pagination
export const fetchQuizResults =
  (options = {}, callback) =>
  async (dispatch, getStore) => {
    dispatch({ type: LOADING_QUIZRESULTS, payload: true });

    const {
      name,
      school,
      class: className,
      suggestedBook,
      startDate,
      endDate,
      teacherName,
      teacherSchool,
      userId,
      page,
      limit,
      sortBy,
      sortOrder
    } = options;

    // Build query parameters
    const queryParams = new URLSearchParams();

    if (name) queryParams.append("name", name);
    if (school) queryParams.append("school", school);
    if (className) queryParams.append("class", className);
    if (suggestedBook) queryParams.append("suggestedBook", suggestedBook);
    if (startDate) queryParams.append("startDate", startDate);
    if (endDate) queryParams.append("endDate", endDate);
    if (teacherName) queryParams.append("teacherName", teacherName);
    if (teacherSchool) queryParams.append("teacherSchool", teacherSchool);
    if (userId) queryParams.append("userId", userId);
    if (page) queryParams.append("page", page);
    if (limit) queryParams.append("limit", limit);
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);

    const query = queryParams.toString() ? `?${queryParams.toString()}` : "";

    try {
      const response = await axios.get(`quiz/results${query}`);

      const { data, pagination } = response.data;

      dispatch({
        type: FETCH_QUIZRESULTS,
        payload: { quizResults: data, pagination }
      });

      dispatch({ type: LOADING_QUIZRESULTS, payload: false });

      if (callback) callback(response.data);
    } catch (error) {
      console.error("Error fetching quiz results:", error);
      dispatch({ type: LOADING_QUIZRESULTS, payload: false });
    }
  };

// Fetch a single quiz result by ID
export const fetchQuizResult =
  (quizResultId, callback) => async (dispatch, getStore) => {
    try {
      const response = await axios.get(`quiz/results/${quizResultId}`);

      const { data } = response.data;

      dispatch({
        type: FETCH_QUIZRESULT,
        payload: { quizResult: data }
      });

      if (callback) callback(data);
    } catch (error) {
      console.error("Error fetching quiz result:", error);
    }
  };

// Fetch quiz results summary statistics
export const fetchQuizResultSummary =
  (options = {}, callback) =>
  async (dispatch, getStore) => {
    const { school, class: className, startDate, endDate } = options;

    // Build query parameters
    const queryParams = new URLSearchParams();

    if (school) queryParams.append("school", school);
    if (className) queryParams.append("class", className);
    if (startDate) queryParams.append("startDate", startDate);
    if (endDate) queryParams.append("endDate", endDate);

    const query = queryParams.toString() ? `?${queryParams.toString()}` : "";

    try {
      const response = await axios.get(`quiz/results/stats/summary${query}`);

      const { summary } = response.data;

      dispatch({
        type: FETCH_QUIZRESULT_SUMMARY,
        payload: { summary }
      });

      if (callback) callback(summary);
    } catch (error) {
      console.error("Error fetching quiz result summary:", error);
    }
  };

// Delete a quiz result by ID
export const deleteQuizResult =
  (quizResultId, callback) => async (dispatch, getStore) => {
    try {
      await axios.delete(`quiz/results/${quizResultId}`);

      dispatch({
        type: DELETE_QUIZRESULT,
        payload: { quizResultId }
      });

      if (callback) callback();
    } catch (error) {
      console.error("Error deleting quiz result:", error);
      throw error;
    }
  };
